// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"22673ff8","703":"4999795b"}[chunkId] + ".chunk.js";
};